fragment ConstantContactIntegration on ConstantContactIntegration {
    email
    isIntegrationActive
    isContactSyncActive
}
